export const validateNumber = (rule, value, callback) => {
    // 检查是否为数字
    if (isNaN(value)) {
      return callback(new Error("必须输入数字"));
    }
    // 检查最小值
    if (value < 0) {
      return callback(new Error("数字最小0"));
    }
    const integerPart = value.toString().split(".")[0]; // 获取整数部分
    if (integerPart.length > 10) {
      return callback(new Error("整数位不能超过10位"));
    }
    // 检查小数位数
    if (
      value.toString().split(".")[1] &&
      value.toString().split(".")[1].length > 2
    ) {
      return callback(new Error("最多保留两位小数"));
    }
    callback();
  };

  export const validateManage = (rule, value, callback) => {
    // 检查是否为数字
    if (isNaN(value)) {
      return callback(new Error("必须输入数字"));
    }
    // 检查最小值
    if (value < 0) {
      return callback(new Error("数字不能小于0"));
    }
    const integerPart = value.toString().split(".")[0]; // 获取整数部分
    if (integerPart.length > 10) {
      return callback(new Error("整数位不能超过10位"));
    }
    // 检查小数位数
    if (
      value.toString().split(".")[1] &&
      value.toString().split(".")[1].length > 2
    ) {
      return callback(new Error("最多保留两位小数"));
    }
    callback();
  };